import { rest } from 'msw'
import { Transaction } from 'types/transaction'
import mockedTransactionsPagination from '../../../__mocks__/Transactions/paginatedTransactions.json'

export const getTransactionsByWalletId = rest.get<Transaction[]>(
  `${process.env.API_URL}/api/transaction/:walletId`,
  async (req, res, ctx) => {
    return res(
      ctx.set({
        'x-api-list-total': String(mockedTransactionsPagination.paging.total),
        'x-api-list-start': String(mockedTransactionsPagination.paging.offset),
      }),
      ctx.json(mockedTransactionsPagination.transactions)
    )
  }
)

export const proofOfPayment = rest.get(
  `${API_URL}//report/payout/*/proof-of-paymen`,
  async (req, res, ctx) => res(ctx.status(200))
)
